import { Component, OnDestroy } from "@angular/core";
import {GridApi, ICellRendererParams} from '@ag-grid-community/core';
import { FormControl } from "@angular/forms";
import {MatDialog} from '@angular/material/dialog';
import {filter, takeUntil} from 'rxjs/operators';
import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { PoPlanVendors } from "./../../models/planyard.model";
import {CreateVendorItemComponent} from '../../components/dialogs/create-vendor-item/create-vendor-item.component';
import { InventoryService } from "src/app/services/inventory.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { Subject } from "rxjs";

@Component({
  selector: "app-select-option-cell-renderer",
  templateUrl: "./select-option-cell-renderer.component.html",
  styleUrls: ["./select-option-cell-renderer.component.scss"],
})
export class SelectOptionCellRendererComponent implements OnDestroy{
  params: any;
  options: PoPlanVendors[];
  selectedOption: number;
  gridApi: GridApi;
  vendor: any;
  control: FormControl = new FormControl();
  enforceCase: FormControl = new FormControl();
  productId: number;
  isEnforceCase:boolean = false;
  private destroy$ = new Subject<void>();
  
  constructor(
    private dialog: MatDialog,
    private purchasingService: PurchasingService,
    private inventoryService:InventoryService,
    private snackBar:MatSnackBar
  ) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.isEnforceCase = this.params.isEnforceCase
    this.options = this.params.data.vendors;
    this.productId = this.params.data.itemId;
    this.selectedOption = this.params.data.selectedVendorItemId;
    if (this.selectedOption) {
      this.vendor = this.options.find(
        (res) => res.itemVendorId === this.selectedOption
      );
      this.control.patchValue(this.vendor, { emitEvent: false });
      if(this.isEnforceCase){
        this.enforceCase.patchValue(this.vendor.rounding);
      }
    }
    this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => this.saveVendorItemId(e));
  }
 
  saveVendorItemId(e): void {
    this.params.optionsSelected(e.itemVendorId, e.vendorId, this.params.data.itemId);
  }

  newVendorItem() {
    this.dialog
        .open(CreateVendorItemComponent, {
          width: "700px",
          panelClass: "dialog-container-custom",
          data: {
            productId: this.productId,
          },
        })
        .afterClosed()
        .pipe(filter((e) => e))
        .subscribe((e) => {
          if (e) {
            
            const payload = { VendorItemId: e.vendorItemId, planId: this.params.poPlanId() };
            this.purchasingService.SelectItemVendor(payload).pipe(takeUntil(this.destroy$)).subscribe(() => {
              this.params.getPoPlan();
             });
          }
        });
  }

  changeEnforceCase(event,params){
    if(event.target.value){
      const payload = {
        updateCaseRoundingSettingDto: [
          {
            id: params,
            caseRoundingSetting: event.target.value,
          },
        ],
      };
    this.inventoryService.UpdateCaseRoundingSetting(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Enforce Setting has been Updated successfully',
              action: 'Dismiss',
              type: 'success',
            },
          })
      },
     error: (error) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error.error.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          })
      },
     });
    }
    }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
